import { SpecializedEmrService } from './../../../specialized-emr/specialized-emr.service';
import { Component, OnInit, OnDestroy, ViewChild, Input, NgModule } from '@angular/core';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ControlsParams, UserSessionService, AppCodeGroup, SharedModule } from '../../../shared';
import { EnumServiceType } from '../../../enumeration/enum-service-type';
import { PrintComponent } from '../../../blocks/print-component/print-component';
import { OrderPatServiceVm } from '../../../orders/interface/patient-order-parms';
import { RegPatService } from '../../../pricing/reg-pat-service/reg-pat-service';
import { labResultComments, LabResult } from '../../../lab/lab-transaction/lab-test/lab-test-result/lab-result';
import { EmrTaps } from '../../emr-taps/emr-taps.service';
import { EmrPatVitals, ILabRad, PannerData, IMedicalData, EmrPatientParms } from '../../medical-recored.interfaces';
import { TablesData, ITablesData } from './data-table.interface';
import { MedicalRepositoryService } from '../../medical-repository.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'medical-data-popup',
    templateUrl: './medical-data-popup.component.html'
})
export class MedicalDataPopupComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    master: any = <any>{};
    componentType: number;
    // visitSerial: number;
    controlsParams: ControlsParams;
    orderType = EnumServiceType.Any;

    @ViewChild('printComponent') printComponent: PrintComponent;
    @ViewChild('printFileComponent') printFileComponent: PrintComponent;

    displayType: number = 2;
    patient: any;
    tabsData: EmrTaps[] = [];
    patientAgeObj: any = <any>{};
    emrPatData: IMedicalData = <IMedicalData>{}

    vitalsData: EmrPatVitals[] = [];
    selectedTabs: EmrTaps[] = [];

    // new properties for lab details data
    patientData: any;
    patServices: OrderPatServiceVm[] = [];
    RegPatService: RegPatService = <RegPatService>{};
    serviceComment: labResultComments[] = [];
    testData: LabResult[] = [];

    labDataType: number = 1;
    lastLabResult: ILabRad = <ILabRad>{};

    resultDisplayType: number = 1;
    lastlabDetailsResult: ILabRad = <ILabRad>{};

    radResultType: number = 1;
    lastRadResult: ILabRad = <ILabRad>{};

    radDataType: number = 1;
    lastRadDetailsResult: ILabRad = <ILabRad>{};

    vitalsDisplayType: number = 1;
    lastVitalData: EmrPatVitals = <EmrPatVitals>{};

    tables: ITablesData[] = TablesData;

    VitalsBlock: boolean = true;
    OrderBlock: boolean = true;

    constructor(
        private _userSessionService: UserSessionService,
        public translate: TranslateService,
        private _specializedEmr: SpecializedEmrService,
        private _medicalRepo: MedicalRepositoryService
    ) {
        this.controlsParams = new ControlsParams(555, AppCodeGroup.Buttons, true);
    }

    compareService(a, b) {
        if (a.regPatServiceSerial < b.regPatServiceSerial) {
            return -1;
        }
        if (a.regPatServiceSerial > b.regPatServiceSerial) {
            return 1;
        }
        return 0;
    }

    /**
     * {componentType: 500, dynamicDataLoad: true, patientData: {}, selectedTabs: [{tapCode: 'Complain', selected: true}]}
     */
    filteredLabData: any[] = [];
    filteredRadData: any[] = [];
    ngOnInit() {
        // for first time get model key by this way and get seclogins after it
        this.master = this._userSessionService.getModalKey('MedicalDataPopupComponent')['inputs'];
        this.handleDataForModal();

        // second subscribe to model key to get data continiously
        this._userSessionService.getModalKey$()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                this.master = <any>{};
                if (keys.name == 'StockBalanceReviewPopupComponent' && keys.inputs) {
                    this.master = keys.inputs;
                    this.handleDataForModal();
                }
            });
    }

    handleDataForModal() {
        this.selectedTabs = [];
        this.displayType = 2;
        this.componentType = this.master.componentType;
        this.selectedTabs = this.master.selectedTabs;
        if (this.master && this.master.dynamicDataLoad) {
            this.patientData = this.master.patientData;
            this.getEmrDoctorsData();
        } else {
            this.emrPatData = this._medicalRepo.emrMedicalDataRepo; //this.master.emrPatData;
            if (this.emrPatData.Complain) this.emrPatData.Complain = this.emrPatData.Complain.filter(el => el.deleteStatus != 1);
            if (this.emrPatData.Findings) this.emrPatData.Findings = this.emrPatData.Findings.filter(el => el.deleteStatus != 1);
            if (this.emrPatData.Diagnois) this.emrPatData.Diagnois = this.emrPatData.Diagnois.filter(el => el.deleteStatus != 1);
            this.vitalsData = this.master.emrVitals;
            this.patient = this.emrPatData ? this.emrPatData.PannerData : <PannerData>{};

            this.resultDisplayType = this.master.labResultType;
            this.labDataType = this.master.labDataType;
            this.radResultType = this.master.radResultType;
            this.radDataType = this.master.radDataType;
            this.vitalsDisplayType = this.master.vitalsDisplayType;

            if (this.emrPatData.labResult && this.emrPatData.labResult.length > 0) {
                this.patientData = this.emrPatData.labResult[0];
                this.patServices = this.emrPatData.labResult;
                //eng reda for  performance
                // this.testData = this.emrPatData.labResult1;
                // let comments: { commentDescAr: string; commentDescEn: string; sheetCode: number }[] = this.emrPatData.labResult2;
                // if (this.testData.length > 0) {
                //     this.testData.forEach(element => {
                //         element.comments = [];
                //         element.comments.push(...comments.filter(item => item.sheetCode == element.sheetCode));
                //     });
                // }
                // this.serviceComment = this.emrPatData.labResult3;
            }

            if (this.master.loadDataType == 2) {
                this.filteredLabData = this.emrPatData.Lab.filter(el => el.serviceStatusCode == 1);
                this.filteredRadData = this.emrPatData.Rad.filter(el => el.serviceStatusCode == 1);
            } else {
                this.filteredLabData = this.emrPatData.Lab;
                this.filteredRadData = this.emrPatData.Rad;
            }

            if (this.labDataType == 1) {
                if (this.emrPatData.Lab) {
                    this.lastLabResult = this.emrPatData.Lab[0];
                }
                if (this.patServices) {
                    this.patServices.sort(this.compareService);
                    this.lastlabDetailsResult = this.patServices[this.patServices.length - 1];
                }
            }
            if (this.radDataType == 1) {
                if (this.emrPatData.Rad) {
                    this.lastRadResult = this.emrPatData.Rad[0];
                }
                if (this.emrPatData.RadResults) {
                    this.lastRadDetailsResult = this.emrPatData.RadResults[0];
                }
            }
            if (this.vitalsDisplayType == 1) {
                if (this.vitalsData && this.vitalsData[0]) {
                    this.lastVitalData = this.vitalsData[0];
                } else {
                    this.lastVitalData = null
                }
            }

            if (this.patient) {
                this.patientAgeObj = {
                    years: this.patient.patientAge,
                    months: this.patient.patientAgeMonths,
                    days: this.patient.patientAgeDays
                }
            }

            this.printAllSelected();
            if (this.selectedTabs && this.selectedTabs.length > 0) {
                setTimeout(() => { if (this.printFileComponent) { this.printFileComponent.PrintView() } }, 200);
            }
            setTimeout(() => { if (this.printComponent) { this.printComponent.PrintView() } }, 200);
        }
    }

    getEmrDoctorsData() {
        let PatientParms: EmrPatientParms = <EmrPatientParms>{}
        PatientParms.filterByEpisoidVisits = 0;
        PatientParms.filterByVisitsList = 0;
        PatientParms.episoidVisits = '';
        PatientParms.flag = 0;
        PatientParms.patCode = this.patientData.code ? this.patientData.code : this.patientData.patCode;
        PatientParms.visitSerial = this.patientData.visitSerial;
        // this.PatientParms.userId = this.userId;
        let StrArr: string[] = [];
        let userTabsArr = this.selectedTabs.length > 0 ? this.selectedTabs.map(el => { return el.tapCode }) : [];
        if (this.selectedTabs) {

        }
        PatientParms.userTabs = userTabsArr.toString();

        PatientParms.resourceType = this.patientData['lastVisitType'] == 1 ? 11 : 3; //this.resourceType;

        PatientParms.docNurseMode = this._userSessionService.getCurrentMode;
        PatientParms.patLookupList = this.patientData['lastVisitType'] == 1 ? 11 : 3;

        this._specializedEmr.getEmrDoctorsData(PatientParms)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                res => {
                    if (res) {
                        this.emrPatData.Complain = res['data6'];
                        this.emrPatData.Diagnois = res['data8'];
                        this.emrPatData.Findings = res['data14'];
                        this.emrPatData.Allergy = res['data12'];
                        this.emrPatData.Lab = res['data10'].filter(el => el.serviceType == 1);
                        this.emrPatData.Rad = res['data10'].filter(el => el.serviceType == 2);
                        this.emrPatData.Medication = res['data16'];
                        this.patient = res['data'][0];
                    }
                },
                err => { },
                () => {
                    this.printAllSelected();
                    if (this.selectedTabs && this.selectedTabs.length > 0) {
                        setTimeout(() => { if (this.printFileComponent) { this.printFileComponent.PrintView() } }, 200);
                    }
                    setTimeout(() => { if (this.printComponent) { this.printComponent.PrintView() } }, 200);
                }
            )
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    printAllSelected() {

        if (this.selectedTabs && this.selectedTabs.length > 0) {
            this.selectedTabs.forEach(element => {
                if (this.tables.some(el => el.tapCode == element.tapCode && element.selected == true)) {
                    this.tables.find(el => el.tapCode == element.tapCode).selected = true;
                }

                if (element.tapCode == 'Vitals' && element.selected) {
                    this.VitalsBlock = false;
                }

                if ((element.tapCode == 'ORDERS'
                    || element.tapCode == 'ORDERHISTORY'
                    || element.tapCode == 'LAB_ORDERS'
                    || element.tapCode == 'RAD_ORDERS')
                    && element.selected) {
                    this.OrderBlock = false;
                }
            });
        }
    }
    orderAddFinished(e) {
        this._userSessionService.setSessionKey('OrderAddFinished', e);
    }
}
@Component({
    selector: 'general-table',
    template: `
    <table [class]="cssClasses" [ngClass]="{'vital-table' : type == 't01', 'medical-table': type == 't02'}" [id]="type" width="100%">
        <caption [class]="caption" *ngIf="data.length > 0">{{title | translate}}</caption>
        <tr [class]="headRow">
            <th *ngFor="let column of headColumns">{{column | translate}}</th>
        </tr>
        <!-- <ng-template *ngIf="data && data.length > 0"> -->
        <tr *ngFor="let row of data">
            <!-- {{row | json}} -->
            <td *ngFor="let key of bodyColumns">
                <!-- <b class="text-danger">{{key}}</b> -->
                <span *ngIf="key != 'regDate' && key != 'userName' && key != 'highPressure'">{{row[key]}}</span>
                <span *ngIf="key == 'highPressure'">{{row[key] +' / '+ row.lowPressure}}</span>
                <span *ngIf="key == 'userName'">
                    <b *ngIf="row.userID == docId">{{row[key]}}</b>
                    <b class="text-danger" *ngIf="row.userID != docId">{{row[key]}}</b>
                </span>
                <span *ngIf="key == 'regDate'">{{row.regDate | date:'short'}}</span>
            </td>
        </tr>
        <!-- </ng-template> -->
        <tr *ngIf="data.length == 0">
            <td [attr.colspan]="headColumns.length"><b
                    style="letter-spacing: 1px;">{{translate.currentLang == 'ar' ? 'لا يوجد بيانات':'No Data'}}</b>
            </td>
        </tr>
    </table>`
})
export class GeneralTableComponent {
    @Input() data: any[];
    @Input() headColumns: any[];
    @Input() bodyColumns: any[];
    @Input() type: 't01' | 't02';
    @Input() title: string;
    @Input() docId: number;
    @Input() cssClasses: string;
    @Input() caption: string;
    @Input() headRow: string;

    constructor(public translate: TranslateService) { }
}

@NgModule({
    declarations: [GeneralTableComponent],
    imports: [CommonModule, SharedModule],
    exports: [GeneralTableComponent]
})
export class GeneralTableModule { }



